module.exports = __webpack_public_path__ + "img/gas.b99a1632.jpg";